import { Component, OnInit, EventEmitter, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GridApi } from 'ag-grid-community';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { GrantsSummaryService } from 'src/app/services/grants/grants-summary.service';
import { Subject } from 'rxjs';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { AppFunctionsService } from 'src/app/services/app-functions.service';
import { CommonService } from 'src/app/services/common.service';
import { DocumentUploadComponent } from 'src/app/common/document-upload/document-upload.component';
import * as $ from 'jquery';
import { ExtendedFormControlsComponent } from 'src/app/common/extended-form-controls/extended-form-controls.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HeadService } from 'src/app/services/common/headservice';
import { GrantsDatashareService } from 'src/app/services/grants/grants-datashare.service';

@Component({
  selector: 'app-grants-document-upload',
  templateUrl: './grants-document-upload.component.html',
  styleUrls: ['./grants-document-upload.component.scss']
})

export class GrantsDocumentUploadComponent implements OnInit {

  formFields;
  uploadedFiles = ["Attachement one", "Attachment two", "Attachment three"];
  // File upload
  formData: FormData;
  files: any[];
  uploadInput: EventEmitter<any>;
  humanizeBytes: Function;
  dragOver: boolean;
  appid: string = "";
  permission: string;
  permissionCode: string;
  screencode: string;
  docuemntUploadForm: UntypedFormGroup;
  
  action: Subject<any> = new Subject();
  @ViewChild('documentUpload') documentUpload: DocumentUploadComponent;
  @ViewChild('extended') extendedForm: ExtendedFormControlsComponent;

  constructor(
    private router: Router,
    public route: ActivatedRoute,
    private modalService : NgbModal,
    private appFunctions: AppFunctionsService,
    private commonService: CommonService,
    private summaryService: GrantsSummaryService,
    private header: HeadService,
    public grantsDatashare: GrantsDatashareService
    ) { 
      this.files = [];
      this.uploadInput = new EventEmitter<any>();
    this.screencode = route.snapshot.params['code'];
    this.docuemntUploadForm = new UntypedFormGroup({
      ID: new UntypedFormControl(null),
      APPLICATION_ID: new UntypedFormControl(null),
      IS_UPTO_DATE: new UntypedFormControl("", [Validators.required]),
      IS_UPTO_DATENo: new UntypedFormControl("", [Validators.required])
    });
    }

  ngOnInit() {
    this.NavigateToGenInfo();
    this.docuemntUploadForm = new UntypedFormGroup({
      ID: new UntypedFormControl(null),
      APPLICATION_ID: new UntypedFormControl(null),
      IS_UPTO_DATE: new UntypedFormControl("", [Validators.required]),
      IS_UPTO_DATENo: new UntypedFormControl("", [Validators.required])
    });
      //this.criteriaService.getDocumentUploadCriteria().subscribe(criteria => {
      //  this.formFields = criteria.formFields;
      //  this.appFunctions.getFormStructure(this.docuemntUploadForm, this.formFields);

      //});

      var grantapp = this.commonService.getGrantsApp();// "8b3a39fb-99ee-44ce-8c03-c5417eb040d2";
      this.appid = grantapp.ID;

      //this.permission = "";
      this.permissionCode = "GSP04";

    this.permission = this.commonService.getPagePermission(this.permissionCode).toLowerCase();
    if (this.permission == null || this.permission == undefined || this.permission == '') {
      const intervalId = setInterval(() => {
        this.permission = this.commonService.getPagePermission(this.permissionCode).toLowerCase();
        if (this.permission != null && this.permission != undefined && this.permission != '') {
          clearInterval(intervalId);
        }
      }, 1000);
   }
     

      this.getUploadDocument();
    }

  getUploadDocument(): void {
    this.summaryService.getDocumentUpload(this.appid).subscribe((result) => {
      if (result != null) {
        if (result.IS_UPTO_DATE == true) {
          result.IS_UPTO_DATE = "yes";
        }
        else
          result.IS_UPTO_DATE = "no";
        this.docuemntUploadForm.patchValue({
          ID: result.ID,
          APPLICATION_ID: result.APPLICATION_ID,
          IS_UPTO_DATE: result.IS_UPTO_DATE,
          FORMAT_TYPE_ID: result.FORMAT_TYPE_ID
        });



      }
    });
  }
    showFiles() {
      let files = '';
      for (let i = 0; i < this.files.length; i ++) {
        files += this.files[i].name;
         if (!(this.files.length - 1 === i)) {
           files += ',';
        }
      }
      return files;
   }

  startUpload(): void {
      const event: any = {
      type: 'uploadAll',
      url: 'your-path-to-backend-endpoint',
      method: 'POST',
      data: { foo: 'bar' },
      };
      this.files = [];
      this.uploadInput.emit(event);
  }

  cancelUpload(id: string): void {
      this.uploadInput.emit({ type: 'cancel', id: id });
  }

  onUploadOutput(output: any | any): void {

      if (output.type === 'allAddedToQueue') {
      } else if (output.type === 'addedToQueue') {
        this.files.push(output.file); // add file to array when added
      } else if (output.type === 'uploading') {
        // update current data in files array for uploading file
        const index = this.files.findIndex(file => file.id === output.file.id);
        this.files[index] = output.file;
      } else if (output.type === 'removed') {
        // remove file from array when removed
        this.files = this.files.filter((file: any) => file !== output.file);
      } else if (output.type === 'dragOver') {
        this.dragOver = true;
      } else if (output.type === 'dragOut') {
      } else if (output.type === 'drop') {
        this.dragOver = false;
      }
      this.showFiles();
  }

  operations = [
    { name: 'Save', type:'submit', callback: this.save, self: this },
    { name: 'Cancel', type:'button', callback: this.cancel, self: this }
  ]

  onCallbackOperation(opr){
    opr.callback();
  }
  save() {

  }

  SaveDocumentUpload() {
    if (this.appid == null || this.appid == undefined || this.appid == "") {
      let message1 = "Please save the general information first.<br/>";
      this.commonService.ValidationBanner(message1);
      //this.modalService.show(MessageBoxComponent, { data: { heading: 'Validations', content: { heading: '', description: message1 } } });
      return false;
    }
    let isValid = true;
    let message = "";
    var formData = this.docuemntUploadForm.value;
    var isupdateyes = formData["IS_UPTO_DATE"];
    var isupdateno = formData["IS_UPTO_DATENo"];

    if (!this.documentUpload.validateControls()) {
      message += "At least one mandatory document upload/Note us pending.Please upload the document and proceed with save again.<br/>";
      isValid = false;
      this.commonService.ValidationBanner(message);
      //this.modalService.show(MessageBoxComponent, { data: { heading: 'Validations', content: { heading: '', description: message } } });
      return false;
    }

    if ((isupdateyes === null || isupdateyes === "" || isupdateyes === undefined) && (isupdateno === null || isupdateno === "" || isupdateno === undefined))
    {
      $("#IS_UPTO_DATE").addClass("ng-touched ng-invalid validate-error");
      $("#IS_UPTO_DATE").removeClass("ng-untouched ng-valid");
      message += "Please select profile upto date.<br/>";
      isValid = false;
    }
    else {
      $("#IS_UPTO_DATE").addClass("ng-untouched ng-valid");
      $("#IS_UPTO_DATE").removeClass("ng-touched ng-invalid validate-error");
    }
   

    formData["APPLICATION_ID"] = this.appid;
    if (isupdateyes == "yes")
      formData["IS_UPTO_DATE"] = true;
    else
      formData["IS_UPTO_DATE"] = false;
    if (formData["ID"] == null || formData["ID"] == undefined || formData["ID"] == "") {
      this.summaryService.Insert('api/gmdocumentupload/insert', formData).subscribe(summary => {
        // this.documentUpload.saveDocumentUploads(this.appid).subscribe((result) => {
        //   this.getUploadDocument();
        //   this.extendedForm.saveControls(summary.TransactionCode).subscribe(result1 => {
        //     this.commonService.SuccessBanner('Document Upload Saved Successfully.');
        //    // this.modalService.show(MessageBoxComponent, { data: { heading: 'Save', content: { heading: '', description: 'Document Upload Saved Successfully.' } } });
        //   });
        // });
      });
    }
    else {
      this.summaryService.Insert('api/gmdocumentupload/update', formData).subscribe(summary => {
        // this.documentUpload.saveDocumentUploads(this.appid).subscribe((result) => {
        //   this.getUploadDocument();
        //   this.extendedForm.saveControls(summary.TransactionCode).subscribe(result1 => {
        //     this.commonService.SuccessBanner('Document Upload Saved Successfully.');
        //   //  this.modalService.show(MessageBoxComponent, { data: { heading: 'Save', content: { heading: '', description: 'Document Upload Saved Successfully.' } } });
        //   });

        // });
      });
    }
    
    this.documentUpload.getFeatureDocuments();
    //if (this.heading == "Add") {
    //  this.summaryService.Insert('api/gmsignee/insert', formData).subscribe(summary => {
    //    this['self'].modalService.show(MessageBoxComponent, { data: { heading: 'Insert', content: { heading: '', description: 'Data has been inserted successfully.' } } });
    //  });
    //}
    //else {
    //  this.summaryService.Update('api/gmsignee/update', formData).subscribe(summary => {
    //    this['self'].modalService.show(MessageBoxComponent, { data: { heading: 'Update', content: { heading: '', description: 'Data has been updated successfully.' } } });
    //  });
    //}

    if (!isValid) {
      this['self'].modalService.show(MessageBoxComponent, { data: { heading: 'Validations', content: { heading: '', description: message } } });
      return isValid;
    }
      

    //if(this['self'].docuemntUploadForm.valid){
    //  this['self'].modalService.show(MessageBoxComponent, {data:{heading:'Save',content: { heading: '', description: 'Data Saved Successfully.'}}});
    //  //this['self'].docuemntUploadForm.reset();
    //}
  }
  cancel() {
    if(this['self'].docuemntUploadForm.valid){
      this['self'].docuemntUploadForm.reset();
    }
  }

  NavigateToGenInfo() {
      this.appid = this.commonService.appId;
      let MenuModule=this.commonService.getModuleMenu();
      if (this.appid == null || this.appid == undefined || this.appid == "") {
        const modalRefBud2 = this.modalService.open(MessageBoxComponent, {});
        modalRefBud2.componentInstance.Content = { heading: '', content: { heading: '', description: 'Please save General information details to navigate to Document Uploads', operation: { hasConfirm: false } } };
        modalRefBud2.result.then((result) => {
          this.router.navigate(['/home/grants/my-applications/application-ext/:' + 0 + '/genInformsponsorship'],
            { skipLocationChange: true, queryParams: { id: 0, app_ext: true, module: "grants",submodule:MenuModule.module, screen_type: "my-applications" } })
        });
        return false;
      }
  }
  
}
